import {SearchHistoryRecordDto} from '../../explore-view/hooks/requests/use-explore-view-search-history-query';

export interface DocNameSuggestion {
    type: 'document';
}

export interface PrefixSuggestion {
    type: 'prefix';
    prefix: string;
}

export interface CategorySuggestion {
    type: 'category';
    name: string;
    categoryId: string;
    matchedSynonym?: string;
}

export interface NodeSuggestion {
    type: 'node';
    nodeType: string;
    name: string;
    documentAccession?: string;
    nodeId: string | null;
    matchedSynonym?: string;
    taxonName?: string;
}

export const METADATA_FIELD_TYPE = {
    PUBLISHED_BY: 'PUBLISHED_BY',
    CREATED_BY: 'CREATED_BY',
    EDITED_BY: 'EDITED_BY',
    TAG_PUBLIC: 'TAG_PUBLIC',
    TAG_PRIVATE: 'TAG_PRIVATE'
} as const;

export type MetadataField = (typeof METADATA_FIELD_TYPE)[keyof typeof METADATA_FIELD_TYPE];

export interface MetadataSuggestion {
    type: 'metadata';
    fieldType: MetadataField;
    value: string;
    displayName?: string;
}

export interface HistoryRecordSuggestion extends SearchHistoryRecordDto {
    type: 'historyRecord';
}

export type SearchSuggestion =
    | PrefixSuggestion
    | DocNameSuggestion
    | CategorySuggestion
    | NodeSuggestion
    | HistoryRecordSuggestion
    | MetadataSuggestion;

export interface DocNameSearchData extends DocNameSuggestion {
    searchString: string;
}

export type SearchData =
    | DocNameSearchData
    | CategorySuggestion
    | NodeSuggestion
    | MetadataSuggestion;
